var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "tableContainer", staticClass: "table-container" }, [
    _c("div", { ref: "headerBack", staticClass: "header-back" }),
    _vm._v(" "),
    _c("table", [
      _c(
        "thead",
        { ref: "tableHead" },
        [
          _c("th", [_vm._v("年份")]),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(c) {
            return _c("th", { key: c }, [
              _vm._v(
                "\n          " + _vm._s(_vm.tableColumnsTitle[c]) + "\n\t\t  "
              ),
              _vm.columnClickables[c]
                ? _c("img", {
                    attrs: {
                      src: _vm.mapPng,
                      alt: "點選看地圖",
                      "data-column": c
                    },
                    on: { click: _vm.changeCol }
                  })
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.userColumns, function(userCol, index) {
            return _c("th", { key: "user-" + index }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: userCol.title,
                    expression: "userCol.title"
                  }
                ],
                staticClass: "column-title-input",
                attrs: { placeholder: "欄位名稱" },
                domProps: { value: userCol.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(userCol, "title", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.rmPng, alt: "移除欄位" },
                on: {
                  click: function($event) {
                    _vm.rmCol(index)
                  }
                }
              })
            ])
          }),
          _vm._v(" "),
          _vm.applyUserData
            ? _c("th", [
                _c("img", {
                  attrs: { src: _vm.addPng, alt: "新增資料" },
                  on: { click: _vm.addCol }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("th")
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.years, function(y, index) {
            return _c(
              "tr",
              { key: y, class: { lastYear: index == _vm.years.length - 1 } },
              [
                _c("td", { staticClass: "td-year" }, [_vm._v(_vm._s(y))]),
                _vm._v(" "),
                _vm._l(_vm.tableColumns, function(c) {
                  return _c("td", { key: c }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.tableData[index][c]) +
                        "\n          "
                    )
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.userColumns, function(userCol, colIndex) {
                  return _c(
                    "td",
                    {
                      key: "user-data-" + colIndex,
                      staticClass: "user-column"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: userCol.data[index],
                            expression: "userCol.data[index]"
                          }
                        ],
                        staticClass: "data-input",
                        attrs: { type: "number", placeholder: "數值" },
                        domProps: { value: userCol.data[index] },
                        on: {
                          paste: function($event) {
                            _vm.handlePaste($event, colIndex, index)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(userCol.data, index, $event.target.value)
                          }
                        }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.applyUserData ? _c("td") : _vm._e(),
                _vm._v(" "),
                _c("td")
              ],
              2
            )
          }),
          _vm._v(" "),
          _c("tr")
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }